<script>
import NavBar from '@components/nav-bar'
import SideBar from '@components/side-bar'
import RightBar from '@components/right-bar'
import { mapGetters } from 'vuex'

export default {
  components: { NavBar, SideBar, RightBar },
  data() {
    return {
      isMenuCondensed: false,
      user: this.$store ? this.$store.state.auth.currentUser : {} || {},
    }
  },
  watch: {
    isMenuCondensed(newVal, oldVal) {
      localStorage.setItem('isMenuCondensed', newVal);
    }
  },
  created: () => {
    document.body.style.backgroundColor = '';
    document.body.classList.remove('authentication-bg')
    document.body.classList.remove('authentication-bg-pattern')
  },
  methods: {
    toggleMenu() {
      this.isMenuCondensed = !this.isMenuCondensed
      document.body.classList.toggle('sidebar-enable')
      // if (
      //   !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
      //     navigator.userAgent
      //   )
      // )
      document.body.classList.toggle('enlarged')
    },
    toggleRightSidebar() {
      document.body.classList.toggle('right-bar-enabled')
    }
  },
  computed: {
    ...mapGetters({
      showTutorial: 'euroCouponsTutorials/showTutorial',
      tutorialUrl: 'euroCouponsTutorials/getTutorialUrl',
    }),
  },
  // mounted: function(){
    // this.toggleMenu()
    // if (localStorage.getItem('isMenuCondensed') === 'true'){
    //   this.toggleMenu()
    // }
  // }
}
</script>

<template>
  <div id="wrapper">
    <NavBar :user="user" />
    <SideBar :is-condensed="isMenuCondensed" />
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="content-page">
      <div class="content">
        <!-- Start Content-->
        <div class="container-fluid p-1">
          <slot />
          <b-button v-if="showTutorial" 
          v-b-modal.modal-1 
          class="float shadow rounded-circle p-0" 
          variant="outline-primary"
          >
          <i class="fas fa-question"></i>
          </b-button>
          <b-modal id="modal-1"  size="xl" title="Video Guia de Uso" :hide-footer="true" style="width: 100%" >
            <video width="720" height="405" controls >
             <source :src="tutorialUrl" type="video/mp4">
            </video>
            <!-- <div class="vh-100 h-75">
              <iframe class="embed-responsive-item" :src="$store.getters.getUrl" allowfullscreen></iframe>

            </div> -->
            <!-- <iframe width="720" height="405" src="https://www.youtube.com/embed/APRR2Xb0RU0?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
          </b-modal>
        </div>
      </div>
    </div>
    <RightBar />
  </div>
</template>

<style>
.float{
	position:fixed;
	width:60px;
	height:60px;
	bottom:40px;
	right:40px;
	/* background-color:#0C9; */
	color:#121a79;
  background: rgba(12, 8, 238, 0.144);
	border-radius:50px;
	text-align:center;
}
.help {
    background: rgba(12, 8, 238, 0.144);
    position: absolute;
    z-index: 1;
    right: 30px;
    top: 20px;
    font-size: 35px;
    width: 50px;
    height: 50px;
  }
video {
  width: 100%;
  height: auto;
}
</style>